import Vue from 'vue'
import VueRouter from 'vue-router'

const Login = () => import('../views/Login.vue')
const NotFound = () => import('../views/NotFound.vue')
const Home = () => import('../views/home/Home.vue')
const Common = () => import('../views/home/menu/Common.vue')
const Personal = () => import('../views/home/personal/Personal.vue')

//积分规则页面
//学生获奖
const StuAwards = () => import('../views/home/menu/StuAwards.vue')
//学生获奖
const StuAwards_ssdt = () => import('../views/home/menu/StuAwards_ssdt.vue')
//个人荣誉
const SinglePrize = () => import('../views/home/menu/SinglePrize.vue')
//个人荣誉
const SinglePrize_ssdt = () => import('../views/home/menu/SinglePrize_ssdt.vue')//(上实东滩)
//资源研发
const Resource = () => import('../views/home/menu/Resource.vue')
//教师培训
const Cultivate = () => import('../views/home/menu/Cultivate.vue')
//培训讲座
const Cultivate_ssdt = () => import('../views/home/menu/Cultivate_ssdt.vue')//(上实东滩)
//教师进修
const Promotion = () => import('../views/home/menu/Promotion.vue')
const Promotion_ssdt = () => import('../views/home/menu/Promotion_ssdt.vue')//(上实东滩)
// 研修成果

const Paper = () => import('../views/home/menu/result/Paper.vue')//论文
const Paper_ssdt = () => import('../views/home/menu/result/Paper_ssdt.vue')//论文
const CaseLesson = () => import('../views/home/menu/result/CaseLesson.vue')//案例、课例等获奖
const Curriculum = () => import('../views/home/menu/result/Curriculum.vue')//课题
const Curriculum_ssdt = () => import('../views/home/menu/result/Curriculum_ssdt.vue')//课题(上实东滩)
const Lessonplan = () => import('../views/home/menu/result/Lessonplan.vue')//教案
const Competition = () => import('../views/home/menu/result/Competition.vue')//比武课
const Public = () => import('../views/home/menu/result/Public.vue')//公开教学
const Public_ssdt = () => import('../views/home/menu/result/Public_ssdt.vue')//公开教学(上实东滩)
const jyjxzl = () => import('../views/home/menu/result/Examine.vue')//检查
const ztjz = () => import('../views/home/menu/result/Ztjz.vue')//专题讲座
const microVedio = () => import('../views/home/menu/result/MicroVedio.vue')//微视频
const mtyj_zysj = () => import('../views/home/menu/result/Mtyj.vue')//命题研究
//带教工作
const Guidance = () => import('../views/home/menu/Guidance.vue')
//学生德育
const Contest = () => import('../views/home/menu/character/Contest.vue')//德育比赛
const Line = () => import('../views/home/menu/character/Line.vue')//线条
//管理工作
const Management = () => import('../views/home/menu/Management.vue')
//工作负荷
const Pressure = () => import('../views/home/menu/Pressure.vue')
// 系统管理
const Archives = () => import('../views/home/menu/SysManagement/Archives.vue')//档案管理
const Score = () => import('../views/home/menu/SysManagement/Score.vue')//积分管理
const Group = () => import('../views/home/menu/SysManagement/Group.vue')//组别管理
const Warning = () => import('../views/home/menu/SysManagement/Warning.vue')//组别管理
// 报表统计
const Comprehensive = () => import('../views/home/menu/ReportForm/Comprehensive.vue')  //综合榜单
const Itemized = () => import('../views/home/menu/ReportForm/Itemized.vue')//分项榜单
// 个人中心
const Info = () => import('../views/home/personal/Info.vue')
const Plan = () => import('../views/home/personal/Plan.vue')
const PerScoreTable = () => import('../views/home/personal/PerScoreTable.vue')
const PerScoreTable_ssdt = () => import('../views/home/personal/PerScoreTable_ssdt.vue')
const Password = () => import('../views/home/personal/Password.vue')
//学校荣誉
const SchoolAward = () => import('../views/home/menu/SchoolAward.vue')
const MajorProject = () => import('../views/home/menu/result/MajorProject.vue')
//使用手册
const ServiceManual = () => import('../views/home/menu/ServiceManual.vue')
const ServiceManualEdit = () => import('../views/home/menu/ServiceManualEdit.vue')
const ServiceManualDetail = () => import('../views/home/menu/ServiceManualDetail.vue')

//平台统计
const TeacherSta = () => import('../views/home/menu/TeacherSta.vue')
const SchoolSta = () => import('../views/home/menu/SchoolSta.vue')
// 教师表现
const TeacherPerformance = () => import('../views/home/menu/TeacherPerformance.vue')
Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/login' },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/notfound',
    component: NotFound
  },
  {
    path: '/home',
    component: Home,
    children: [
      {
        path: '/common', component: Common, children: [
          // 配置一个默认展示的组件
          { path: 'stu-prize', component: StuAwards },
          { path: 'stu-prize_ssdt', component: StuAwards_ssdt },
          { path: 'single-prize', component: SinglePrize },
          { path: 'single-prize_ssdt', component: SinglePrize_ssdt },
          { path: 'resource', component: Resource },
          { path: 'cultivate', component: Cultivate },
          { path: 'cultivate_ssdt', component: Cultivate_ssdt },
          { path: 'promotion', component: Promotion },
          { path: 'promotion_ssdt', component: Promotion_ssdt },
          { path: 'contest', component: Contest },
          { path: 'line', component: Line },
          { path: 'management', component: Management },
          { path: 'guidance', component: Guidance },
          { path: 'pressure', component: Pressure },
          { path: 'paper', component: Paper },
          { path: 'paper_ssdt', component: Paper_ssdt },
          { path: 'case-lesson', component: CaseLesson },
          { path: 'curriculum', component: Curriculum },
          { path: 'curriculum_ssdt', component: Curriculum_ssdt },
          { path: 'lessonplan', component: Lessonplan },
          { path: 'competition', component: Competition },
          { path: 'publicTeaching', component: Public },
          { path: 'publicTeaching_ssdt', component: Public_ssdt },
          { path: 'jyjxzl', component: jyjxzl },
          { path: 'archives', component: Archives },
          { path: 'score', component: Score },
          { path: 'group', component: Group },
          { path: 'Warning', component: Warning },
          { path: 'comprehensive', component: Comprehensive },
          { path: 'alone', component: Itemized },
          { path: 'mtyj_zysj', component: mtyj_zysj },
          { path: 'ztjz', component: ztjz },
          { path: 'microVedio', component: microVedio },
          { path: 'school-award', component: SchoolAward },
          { path: 'major-project', component: MajorProject },
          { path: 'school-sta', component: SchoolSta },
          { path: 'teacher-sta', component: TeacherSta },
          {
            path: 'service-manual', component: ServiceManual
          },
          {
            path: 'service-manual-edit', component: ServiceManualEdit
          },
          {
            path: 'service-manual-detail', component: ServiceManualDetail
          },
          {
            path: 'teacher-performance', component: TeacherPerformance
          },
        ]
      },
      //个人中心
      {
        path: '/personal', component: Personal, children: [
          { path: 'info', component: Info },
          { path: 'plan', component: Plan },
          { path: 'password', component: Password },
          { path: 'perscoretable', component: PerScoreTable },
          { path: 'perscoretable_ssdt', component: PerScoreTable_ssdt },
          { path: 'itemized', component: Itemized },
        ]
      },
    ]
  }
]

const router = new VueRouter({
  routes
})

// to 到哪去
// from 从哪来
// next() 放行, next(路径) 拦截到对应的路由
router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {  //如果未匹配到路由
    from.path ? next({ path: from.path }) : next('/notfound');   //如果上级也未匹配到路由则跳转主页面，如果上级能匹配到则转上级路由
  } else {
    next();    //如果匹配到正确跳转
  }
})

export default router
